import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import UtimacoCircuitSwitchList from './containers/UtimacoCircuitSwitchList';
import UtimacoCircuitSwitchCreate from './containers/UtimacoCircuitSwitchCreate';
import UtimacoCircuitSwitchEdit from './containers/UtimacoCircuitSwitchEdit';
import UtimacoCircuitSwitchView from './containers/UtimacoCircuitSwitchView';
import { MISCELLANEOUS, SYSTEM_CONFIGURATION_ROUTE, UTIMACO_CIRCUIT_SWITCH_ROUTE } from '../../constants';

interface Props {
}

const UtimacoCircuitSwitch: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_CIRCUIT_SWITCH_ROUTE}`}>
        <UtimacoCircuitSwitchList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_CIRCUIT_SWITCH_ROUTE}/create`}>
        <UtimacoCircuitSwitchCreate />
      </Route>
      {/* <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_CIRCUIT_SWITCH_ROUTE}/edit`}>
        <UtimacoCircuitSwitchEdit />
      </Route> */}
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${UTIMACO_CIRCUIT_SWITCH_ROUTE}/view`}>
        <UtimacoCircuitSwitchView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default UtimacoCircuitSwitch;
